export default "__VITE_ASSET__DMYs0nvo__"